import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import TenantDetail from '../components/tenant/TenantDetail';
import { PageTitle } from '../components/common/PageTitle';

const TenantDetailPage : FC= () => {

    return (
        <CommonPage selectBtnIndex={0}>
            <PageTitle title="テナント詳細" />
            <TenantDetail />
        </CommonPage>
    )
}

export default TenantDetailPage;